import { Button, IconButton, InputAdornment, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { submitButtonStyles } from "./theme";
import { useAccountMigration } from "@src/entities/login";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { InputField } from "@src/shared/ui/InputField";
import {
  AccountMigrationFormValues,
  AccountMigrationSchema,
} from "./constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

import styles from "./AccountMigration.module.scss";

export const AccountMigration = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showDoublePassword, setDoubleShowPassword] = useState(false);
  const { mutate: accountMigration } = useAccountMigration();
  const { isAuthenticated } = useAuthStore();

  const [searchParams] = useSearchParams();
  const login =
    searchParams.get("login") !== "null" ? searchParams.get("login") ?? "" : "";

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<AccountMigrationFormValues>({
    defaultValues: {
      email: login,
      password: "",
      doublePassword: "",
    },
    mode: "onTouched",
    resolver: yupResolver(AccountMigrationSchema) as any,
  });

  const onSubmit = (data: AccountMigrationFormValues) => {
    accountMigration({ login: data.email, new_password: data.password });
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);

  return (
    <>
      <Typography className={styles.formTitle}>
        Создание нового пароля
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <InputField
          control={control}
          name="email"
          label="Почта"
          className={styles.input}
          classNameForLabel={styles.label}
          disabled
        />
        <InputField
          control={control}
          name="password"
          label="Пароль"
          className={styles.input}
          classNameForLabel={styles.label}
          type={showPassword ? "text" : "password"}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    sx={{ color: "#fff", mr: 1 }}
                    onClick={() => setShowPassword((show) => !show)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        <InputField
          control={control}
          name="doublePassword"
          label="Повторите пароль"
          className={styles.input}
          classNameForLabel={styles.label}
          type={showDoublePassword ? "text" : "password"}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    sx={{ color: "#fff", mr: 1 }}
                    onClick={() => setDoubleShowPassword((show) => !show)}
                    edge="end"
                  >
                    {showDoublePassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        <Button
          disabled={!isValid}
          type="submit"
          variant="contained"
          className={styles.button}
          sx={submitButtonStyles}
        >
          Отправить
        </Button>
      </form>
    </>
  );
};
